<template>
  <div class="login" id="login">
    <v-container class="content-box px-4 pb-16">
      <h1 class="title-style">認定証自動発行システム</h1>
      <v-form ref="form" v-model="valid" class="login-form" lazy-validation>
        <div class="label-style">ログインID</div>
        <v-text-field
          v-model="loginBody.login"
          type="text"
          :rules="usernameRules"
          outlined
          dense
          v-on:keyup.enter="login"
        ></v-text-field>
        <div class="label-style">パスワード</div>
        <v-text-field
          outlined
          dense
          hide-details="auto"
          v-on:keyup.enter="login"
          v-model="loginBody.password"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          :rules="passwordRules.concat(loginSuccess)"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <input v-model="loginBody.is_admin" type="hidden" />
      </v-form>
      <div id="login-btn" class="d-flex justify-center pt-3 py-15">
        <v-btn
          class="txt-white btn-login button-size"
          large
          width="200px"
          height="40px"
          @click="login"
          >ログイン</v-btn
        >
      </div>
    </v-container>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import { login } from "@/api/common";
import validations from "@/utils/common-validation";

export default {
  name: 'Login',
  computed: {
    ...mapGetters(["getLoading"]),
    loading() {
      return this.getLoading;
    },
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    },
  },
  data: () => ({
    loginBody: {
      password: "",
      login: "",
      api_token: "",
      is_admin: ""
    },
    showPassword: false,
    valid: true,
    usernameRules: [
      v => validations.required(v),
    ],
    passwordRules: [
      v => validations.required(v),
    ],
    showError: false,
    loginSuccess: true,
    userinfo: [],
  }),
  methods: {
    async login() {
      this.loginSuccess = true;
      await this.$refs.form.validate();
      if (!this.valid) {
        return;
      }

      await login(this.loginBody).then((response) => {
        if (response.success == true) {
          localStorage.setItem("apiToken", response.api_token);
          this.userInfo = response.data;
          this.$store.commit("SET_USERINFO", response.data);
        } else {
          this.loginSuccess = 'ログインIDまたはパスワードの入力が誤っています';
        }
      }).catch(() => {
        this.loginSuccess = 'ログインIDまたはパスワードの入力が誤っています';
      });

      if (this.loginSuccess !== true) {
        return;
      }
      if (this.isAdmin) {
        localStorage.setItem("adminUserInfo", JSON.stringify(this.userInfo));
        this.$router.push({
          name: "Users",
        });
      } else {
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
        this.$router.push({
          name: "Certificate",
        });
      }
    }
  },
  mounted() {
    this.loginBody.is_admin = this.isAdmin;
  }
}
</script>

<style lang="scss" scoped>
.admin-menu {
  .content-box {
    .title-style {
      color: $admin-primary;
      text-align: center;
    }
    .btn-login {
      background-color: $admin-primary;
    }
  }
}
.user-menu {
  .content-box {
    .title-style {
      color: $user-primary;
      text-align: center;
    }
    .btn-login {
      background-color: $user-primary !important;
    }
  }
}
.content-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .title-style {
    margin-top: 170px;
    font-family: $family-normal;
    font-weight: bold;
    letter-spacing: 2px;
    font-size: $size-login-title;
  }
  .login-form {
    width: 400px;
    margin-top: 41px;
    .label-style {
      color: $color-label;
      font-size: $size-label;
    }
  }
  .login-tip,
  .regist-tip {
    color: $color-text;
    font-size: $size-tip;
    line-height: 3;
    a {
      color: $normal-primary;
      text-decoration: none;
    }
  }
  .regist-tip {
    margin-top: 30px;
    color: $normal-primary;
  }
  .btn-login {
    font-size: $size-btn-font;
    font-weight: bold;
    color: $white;
  }
}
@media screen and (max-width: $size-mobile) {
  .content-box {
    .title-style {
      margin-top: 70px;
      font-size: $size-page-title;
    }
    .login-form {
      width: 100%;
      .label-style {
        color: $color-label;
      }
    }
    .login-tip,
    regist-tip {
      width: 100%;
    }
  }
}
#login-btn {
  margin-top: 32px;
}
//ThemeAdmin
.ThemeAdmin {
  .content-box {
    .title-style {
      color: $admin-secondary;
      text-align: center;
    }
    .btn-login {
      background-color: $admin-primary !important;
      color: $admin-primary_label !important;
    }
    .login-tip {
      a {
        color: $admin-primary;
      }
    }
  }
  #login {
    .login-form {
      .v-input__control {
        .v-input__slot {
          border-radius: 7px;
          .v-input__append-inner {
            .v-icon {
              color: $admin-primary !important;
              caret-color: $admin-primary !important;
            }
          }
        }
      }
    }
  }
  .v-icon {
    color: $admin-primary !important;
    caret-color: $admin-primary !important;
  }
  .primary--text {
    color: $admin-primary !important;
    caret-color: $admin-primary !important;
  }
}
.ThemeNormal {
  .content-box {
    .title-style {
      text-align: center;
      color: $user-primary;
    }
    .btn-login {
      background-color: $user-primary !important;
    }
    .login-tip {
      a {
        color: $user-primary;
      }
    }
  }
  #login {
    .login-form {
      .v-input__control {
        .v-input__slot {
          border-radius: 7px;
          .v-input__append-inner {
            .v-icon {
              color: $user-primary !important;
              caret-color: $user-primary !important;
            }
          }
        }
      }
    }
  }
  .v-icon {
    color: $user-primary !important;
    caret-color: $user-primary !important;
  }
}
</style>
<style>
.ThemeAdmin .mdi-eye::before {
  color: #f4c500 !important;
}
.ThemeAdmin .mdi-eye-off::before {
  color: #f4c500 !important;
}
.ThemeNormal .mdi-eye::before {
  color: #043099 !important;
}
.ThemeNormal .mdi-eye-off::before {
  color: #043099 !important;
}
</style>